var _circle, _path, _path2, _circle2, _g, _circle3, _g2, _circle4, _g3, _circle5, _g4, _circle6, _g5, _circle7, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCautiousEsg = function SvgCautiousEsg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161,
    height: 58,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 131.826,
    cy: 29.127,
    r: 28.472,
    fill: "#EFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    d: "M132.012 35.71c7.364 0 13.311-5.832 13.311-12.99-7.335-.027-13.311 5.804-13.311 12.99M117.59 22.72c0 7.186 5.976 12.99 13.312 12.99 0-7.158-5.977-12.99-13.312-12.99M132.012 48.704c7.364 0 13.311-5.831 13.311-12.99-7.335-.027-13.311 5.804-13.311 12.99M117.59 35.714c0 7.186 5.976 12.99 13.312 12.99 0-7.158-5.977-12.99-13.312-12.99M132.012 22.543c7.364 0 13.311-5.832 13.311-12.99-7.335-.027-13.311 5.804-13.311 12.99M117.59 9.553c0 7.186 5.976 12.99 13.312 12.99 0-7.158-5.977-12.99-13.312-12.99"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cautious-esg_svg__a",
    width: 117,
    height: 58,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.373.655h116.38v57.151H.373z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#cautious-esg_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cautious-esg_svg__b",
    width: 117,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.563,
    cy: 59.435,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cautious-esg_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C0EEC0",
    stroke: "#C0EEC0",
    d: "m53.49 53.624 3.41-1.2L39.975 2.866l-18.338 8.976-10.633 13.9z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cautious-esg_svg__c",
    width: 117,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.563,
    cy: 59.435,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cautious-esg_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#92DE63",
    stroke: "#92DE63",
    d: "M56.85 50.515 39.957.54 58.36-3.715 77.44.098l-16.43 50.67z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cautious-esg_svg__d",
    width: 117,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.563,
    cy: 59.435,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cautious-esg_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#125A42",
    stroke: "#125A42",
    d: "M106.681 23.47 68.068 49.845l3.868 7.525h46.348l-3.587-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cautious-esg_svg__e",
    width: 117,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.563,
    cy: 59.435,
    r: 57.69,
    fill: "#D9D9D9",
    stroke: "#FDEFE0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cautious-esg_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFE",
    stroke: "#EFE",
    d: "m10.445 23.47 38.612 26.375-3.869 7.525H-1.159l3.587-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "cautious-esg_svg__f",
    width: 117,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.563,
    cy: 59.435,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cautious-esg_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    stroke: "#169B62",
    d: "m64.927 52.22-3.43-1.142L77.6 1.246l18.484 8.671 10.862 13.721z"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.562,
    cy: 59.442,
    r: 26.263,
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#125A42",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "m44.991 56.404-3.766-3.865 3.955-3.855M59.222 52.544l-16.5-.008"
  })));
};
export { SvgCautiousEsg as ReactComponent };
export default __webpack_public_path__ + "images/cautious-esg.svg";